import { inject } from '@angular/core';
import { Observable } from 'rxjs';
import { SessionGateService, SessionState } from './session-gate.service';

export type { SessionState } from './session-gate.service';

/** Settles the session for a guard. Must run in an injection context. */
export function waitForSession(): Observable<SessionState> {
  return inject(SessionGateService).wait();
}
